import { CommonModule,DOCUMENT } from '@angular/common';
import { Component, OnInit, inject,  Inject, } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-package',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './package.html',
  styleUrl: './package.css',
})
export class Package implements OnInit {


   constructor(
    @Inject(DOCUMENT) private document: Document,
    private title: Title,
    private meta: Meta,
  ) {}
  
  // Inject HttpClient
  private http = inject(HttpClient);
  
  // Array to hold membership plan data from API
  membershipPlans: any[] = [];
  
  // Array to hold packages data from API (beauty treatments)
  packages: any[] = [];
  
  // Terms & Conditions lines from API
  terms: any[] = [];
  isLoadingTerms: boolean = false;

  // Loading states
  isLoadingMembershipPlans: boolean = false;
  isLoadingPackages: boolean = false;
  
  // Error messages
  errorMessageMembershipPlans: string = '';
  errorMessagePackages: string = '';
  
  // Default membership plans (fallback if API fails)
  defaultMembershipPlans = [
    {
      planName: 'Silver Plan',
      dripSession: '8 Sessions',
      beautyTreatment: '2 Treatments',
      antiAgeing: '---',
      isActive: true
    },
    {
      planName: 'Gold Plan',
      dripSession: '25 Sessions',
      beautyTreatment: '4 Treatments',
      antiAgeing: '1 Session',
      isActive: true
    },
    {
      planName: 'Platinum Plan',
      dripSession: '40 Sessions',
      beautyTreatment: '8 Treatments',
      antiAgeing: '2 Sessions',
      isActive: true
    }
  ];


  
  ngOnInit() {
    this.setSeo();
    this.loadMembershipPlans();
    this.loadPackages();
    this.loadTerms();
  }


  // Fetch Terms & Conditions (active rows, ordered by DisplayOrder)
  loadTerms() {
    this.isLoadingTerms = true;

    // Use the same API base as your other calls (localhost for testing, clients-api in production)
    const apiUrl = 'https://crm-api.redmonkwellness.com/Packages/GetActiveTerms';

    this.http.post<any>(apiUrl, {}).subscribe({
      next: (response) => {
        if (response.success && response.Items) {
          this.terms = response.Items;
        }
        this.isLoadingTerms = false;
      },
      error: (error) => {
        console.error('Error loading terms:', error);
        this.isLoadingTerms = false;
      }
    });
  }
  // Method to fetch membership plans from API
  loadMembershipPlans() {
    this.isLoadingMembershipPlans = true;
    this.errorMessageMembershipPlans = '';
    
    // API endpoint for membership plans
   // const apiUrl = 'https://crm-api.redmonkwellness.com/MembershipPlan/GetPlan';

   const apiUrl = 'https://crm-api.redmonkwellness.com/MembershipPlan/GetPlan';
    
    this.http.post<any>(apiUrl, {}).subscribe({
      next: (response) => {
        console.log('Membership Plans API Response:', response);
        
        if (response.success && response.packages) {
          // Transform API data to match your HTML structure
          this.membershipPlans = this.transformMembershipPlans(response.packages);
          console.log('Membership Plans loaded:', this.membershipPlans);
        } else {
          this.errorMessageMembershipPlans = response.message || 'Failed to load membership plans';
          // Fallback to default plans
          this.membershipPlans = [...this.defaultMembershipPlans];
        }
        this.isLoadingMembershipPlans = false;
      },
      error: (error) => {
        console.error('Error loading membership plans:', error);
        this.errorMessageMembershipPlans = `Failed to load membership plans: ${error.message || 'Unknown error'}`;
        // Fallback to default plans
        this.membershipPlans = [...this.defaultMembershipPlans];
        this.isLoadingMembershipPlans = false;
      }
    });
  }

  // Method to fetch packages (beauty treatments) from API
  loadPackages() {
    this.isLoadingPackages = true;
    this.errorMessagePackages = '';
    
    // API endpoint for packages (beauty treatments)
    const apiUrl = 'https://crm-api.redmonkwellness.com/Packages/GetPackages';
    
    this.http.post<any>(apiUrl, {}).subscribe({
      next: (response) => {
        console.log('Packages API Response:', response);
        
        if (response.success && response.packages) {
          // Transform API data to match your HTML structure
          this.packages = this.transformPackages(response.packages);
          console.log('Packages loaded:', this.packages);
        } else {
          this.errorMessagePackages = response.message || 'Failed to load packages';
          // Fallback to default packages
          // this.packages = [...this.defaultPackages];
        }
        this.isLoadingPackages = false;
      },
      error: (error) => {
        console.error('Error loading packages:', error);
        this.errorMessagePackages = `Failed to load packages: ${error.message || 'Unknown error'}`;
        // Fallback to default packages
        // this.packages = [...this.defaultPackages];
        this.isLoadingPackages = false;
      }
    });
  }

  // Transform membership plans data to match HTML structure
  transformMembershipPlans(apiPlans: any[]): any[] {
    return apiPlans
      .filter(plan => plan.isActive) // Only show active plans
      .sort((a, b) => a.Amount - b.Amount) // Sort by amount
      .map(plan => {
        // Format the plan name
        let planName = plan.PlanName || '';
        if (!planName.toLowerCase().includes('plan')) {
          planName += ' Plan';
        }
        
        // Format values with proper labels
        return {
          planName: planName,
          dripSession: `${plan.DripSession || 0} Sessions`,
          beautyTreatment: `${plan.BeautyTreatment || 0} Treatments`,
          antiAgeing: plan.AntiAgeing > 0 ? `${plan.AntiAgeing} Session${plan.AntiAgeing > 1 ? 's' : ''}` : '---',
          amount: plan.Amount || 0,
          description: plan.Description || '',
          isActive: plan.isActive
        };
      });
  }

  // Transform packages data to match HTML structure
  transformPackages(apiPackages: any[]): any[] {
    // Filter active packages and sort if needed
    return apiPackages
      .filter(pkg => pkg.isActive)
      .map(pkg => ({
        PackageName: pkg.PackageName || 'Treatment',
        Description: pkg.Description || pkg.Benefits || 'Advanced beauty treatment',
        Price: pkg.Price || 0,
        Quantity: pkg.Quantity || 0,
        PackageType: pkg.PackageType || 'Beauty Treatment'
      }));
  }

  // Get the membership plans to display (either from API or default)
  getDisplayMembershipPlans() {
    return this.membershipPlans.length > 0 ? this.membershipPlans : this.defaultMembershipPlans;
  }

  // Get the packages to display (either from API or default)
  getDisplayPackages() {
    return this.packages.length > 0 ? this.packages : [];
  }

  // Check if any data is loading
  get isLoading() {
    return this.isLoadingMembershipPlans || this.isLoadingPackages;
  }



private setSeo(): void {

  // =========================
  // SEO DATA
  // =========================

  const pageTitle =
    'IV Therapy Packages in Mumbai | Red Monk Wellness';

  const description =
    'Explore IV therapy packages in Mumbai at Red Monk Wellness, with wellness and beauty IV options designed around individual health, beauty and wellness goals.';

  const canonicalUrl =
    'https://www.redmonkwellness.com/package';

  const ogImage =
    'https://www.redmonkwellness.com/assets/images/services/houseof-hydration-thumb.png';

  // =========================
  // TITLE
  // =========================

  this.title.setTitle(pageTitle);

  // =========================
  // BASIC META
  // =========================

  this.meta.updateTag({
    name: 'description',
    content: description
  });

  this.meta.updateTag({
    name: 'robots',
    content:
      'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1'
  });

  // =========================
  // OPEN GRAPH
  // =========================

  this.meta.updateTag({
    property: 'og:type',
    content: 'website'
  });

  this.meta.updateTag({
    property: 'og:locale',
    content: 'en_IN'
  });

  this.meta.updateTag({
    property: 'og:site_name',
    content: 'Red Monk Wellness'
  });

  this.meta.updateTag({
    property: 'og:title',
    content: pageTitle
  });

  this.meta.updateTag({
    property: 'og:description',
    content: description
  });

  this.meta.updateTag({
    property: 'og:url',
    content: canonicalUrl
  });

  this.meta.updateTag({
    property: 'og:image',
    content: ogImage
  });

  this.meta.updateTag({
    property: 'og:image:alt',
    content: 'IV Therapy Packages at Red Monk Wellness'
  });

  this.meta.updateTag({
    property: 'og:image:type',
    content: 'image/png'
  });

  // =========================
  // TWITTER / X
  // =========================

  this.meta.updateTag({
    name: 'twitter:card',
    content: 'summary_large_image'
  });

  this.meta.updateTag({
    name: 'twitter:title',
    content: pageTitle
  });

  this.meta.updateTag({
    name: 'twitter:description',
    content: description
  });

  this.meta.updateTag({
    name: 'twitter:image',
    content: ogImage
  });

  this.meta.updateTag({
    name: 'twitter:image:alt',
    content: 'IV Therapy Packages at Red Monk Wellness'
  });

  // =========================
  // CANONICAL URL
  // =========================

  let canonical = this.document.querySelector(
    'link[rel="canonical"]'
  ) as HTMLLinkElement | null;

  if (!canonical) {
    canonical = this.document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    this.document.head.appendChild(canonical);
  }

  canonical.setAttribute('href', canonicalUrl);

  // =========================
  // SITEMAP
  // =========================

  let sitemap = this.document.querySelector(
    'link[rel="sitemap"]'
  ) as HTMLLinkElement | null;

  if (!sitemap) {
    sitemap = this.document.createElement('link');
    sitemap.setAttribute('rel', 'sitemap');
    sitemap.setAttribute('type', 'application/xml');
    sitemap.setAttribute('title', 'Sitemap');
    this.document.head.appendChild(sitemap);
  }

  sitemap.setAttribute(
    'href',
    'https://www.redmonkwellness.com/sitemap.xml'
  );

  // =========================
  // ORGANIZATION SCHEMA
  // =========================

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://www.redmonkwellness.com/#organization',
    name: 'Red Monk Wellness',
    url: 'https://www.redmonkwellness.com/',
    logo: {
      '@type': 'ImageObject',
      url: 'https://www.redmonkwellness.com/assets/images/Redmonk-Wellness-Logo-w.png'
    },
    description:
      'Red Monk Wellness offers skin, hair, aesthetic and wellness treatments through its clinics in Mumbai and Kolkata.',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-62-62-62-03-03',
      contactType: 'Customer Service',
      areaServed: 'IN',
      availableLanguage: 'English'
    },
    sameAs: [
      'https://www.linkedin.com/company/red-monk-wellness',
      'https://www.facebook.com/redmonkwellness'
    ]
  };

  // =========================
  // WEBPAGE SCHEMA
  // =========================

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${canonicalUrl}#webpage`,
    url: canonicalUrl,
    name: pageTitle,
    headline: 'IV Therapy Packages in Mumbai',
    description,
    isPartOf: {
      '@type': 'WebSite',
      '@id': 'https://www.redmonkwellness.com/#website',
      name: 'Red Monk Wellness',
      url: 'https://www.redmonkwellness.com/'
    },
    about: {
      '@id': 'https://www.redmonkwellness.com/#organization'
    },
    breadcrumb: {
      '@id': `${canonicalUrl}#breadcrumb`
    },
    inLanguage: 'en-IN'
  };

  // =========================
  // BREADCRUMB SCHEMA
  // =========================

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${canonicalUrl}#breadcrumb`,
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: 'https://www.redmonkwellness.com/home'
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'IV Therapy Packages',
        item: canonicalUrl
      }
    ]
  };

  // =========================
  // ADD / UPDATE JSON-LD SCHEMAS
  // =========================

  const schemas = [
    {
      id: 'organization-schema',
      data: organizationSchema
    },
    {
      id: 'webpage-schema',
      data: webpageSchema
    },
    {
      id: 'breadcrumb-schema',
      data: breadcrumbSchema
    }
  ];

  schemas.forEach(({ id, data }) => {
    let script = this.document.getElementById(
      id
    ) as HTMLScriptElement | null;

    if (!script) {
      script = this.document.createElement('script');
      script.type = 'application/ld+json';
      script.id = id;
      this.document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(data);
  });
}


}